import React, { useState, useEffect } from "react"
import ScrollIntoView from "react-scroll-into-view"
import smoothscroll from "smoothscroll-polyfill"
import { Link } from "gatsby"

import {
  Section,
  Container,
  LogoLink,
  Logo,
  Hamburger,
  MenuIcon,
  Menu,
  MobileMenu,
  MenuItem,
} from "./styles"

import logo from "../../../assets/scindo-header.svg"
import logoColor from "../../../assets/scindo-header-color.svg"

import useWidth from "../../hooks/UseWidth"

const Header = ({ transparent, data }) => {
  // Hooks
  const width = useWidth()
  const mobile = Boolean(width < 992)

  // Check if client
  const isClient = typeof window !== "undefined"
  isClient && smoothscroll.polyfill()

  // State
  const [open, setOpen] = useState(false)
  const [black, setBlack] = useState(false)
  const [hide, setHide] = useState(false)

  // Menu open
  const menuOpen = open && mobile

  useEffect(() => {
    if (!isClient) return undefined

    let lastValue = window.pageYOffset
    let ticking = false
    transparent && setBlack(lastValue >= 100)

    // Minimum scroll distance before we reconsider the hide/show direction —
    // without this, tiny momentum/rubber-band scroll events (a few px in
    // alternating directions) flip `hide` back and forth every frame,
    // making the header visibly jitter up and down instead of settling.
    const DIRECTION_THRESHOLD = 8

    const scrollCheck = () => {
      const newValue = window.pageYOffset
      transparent && setBlack(newValue >= 100)

      if (newValue <= 0) {
        setHide(false)
        lastValue = newValue
        ticking = false
        return
      }

      const delta = newValue - lastValue

      if (newValue > 500 && Math.abs(delta) > DIRECTION_THRESHOLD) {
        setHide(delta > 0)
        lastValue = newValue
      } else if (newValue <= 500) {
        lastValue = newValue
      }

      ticking = false
    }

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(scrollCheck)
        ticking = true
      }
    }

    // Add scroll listener
    window.addEventListener("scroll", onScroll)
    return () => window.removeEventListener("scroll", onScroll)
  }, [isClient, transparent])

  // Freeze content below menu
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : ""
  }, [menuOpen])

  // Toggle menu
  const toggleMenu = () => setOpen(!open)

  // Menu
// Build menu from Prismic (scrolling section links). Labels are overridden
// here rather than in Prismic for section ids that the redesign renamed.
const MENU_LABEL_OVERRIDES = {
  timeline: "Our journey",
}
const sectionItems = data.menu.map((item, i) => (
  <ScrollIntoView
    key={`menu-item-${i}`}
    selector={`#${item.menu_item_section_id}`}
  >
    <MenuItem index={i + 1} onClick={toggleMenu}>
      {MENU_LABEL_OVERRIDES[item.menu_item_section_id] || item.menu_item_title}
    </MenuItem>
  </ScrollIntoView>
))
// Add a separate page link to /media/
const mediaItemIndex = data.menu.length + 1
const mediaItem = (
  <MenuItem
    key="menu-item-media"
    index={mediaItemIndex}
    as={Link}      // styled MenuItem, but rendered as Gatsby <Link>
    to="/media/"
    onClick={toggleMenu}
  >
    Media
  </MenuItem>
)
// Final menu = old section items + Media link
const menu = [...sectionItems, mediaItem]

  return (
    <Section open={menuOpen} hide={hide} black={black}>
      <Container>
        <LogoLink to="/">
          <Logo src={menuOpen || black ? logoColor : logo} alt="Scindo" />
        </LogoLink>
        <Menu>{menu}</Menu>
        <Hamburger onClick={toggleMenu} aria-label="Menu">
          <MenuIcon open={menuOpen}>
            <span />
            <span />
            <span />
          </MenuIcon>
        </Hamburger>
      </Container>
      {open && mobile && <MobileMenu>{menu}</MobileMenu>}
    </Section>
  )
}

export default Header
